/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Favorite_SubtitleInputs */

const en_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save your favorite tree species, durations, and tags for quick focus.`)
};

const ar_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احفظ أنواع الأشجار المفضلة لديك، والفترات الزمنية، وعلامات للتركيز السريع.`)
};

const de_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern Sie Ihre bevorzugten Baumarten, Laufzeiten und Tags, um sie schnell wiederzufinden.`)
};

const es_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda tus especies de árboles, duraciones y etiquetas favoritas para una concentración rápida.`)
};

const fr_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrez vos espèces d’arbres préférées, vos durées ainsi que vos tags pour lancer une session rapidement`)
};

const it_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le specie di alberi, le durate e i tag che preferisci per concentrarti rapidamente.`)
};

const ja_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りの樹種・時間・タグを保存して、すばやく集中`)
};

const ko_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좋아하는 나무 종류, 기간, 태그를 저장하여 퀵 포커스에 사용할 수 있어요.`)
};

const pt_br_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salve suas combinações favoritas de espécie de árvore, durações e marcadores para manter o foco rapidamente.`)
};

const ru_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраняйте любимые виды деревьев, продолжительности и теги для быстрой фокусировки.`)
};

const th_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกสายพันธุ์ต้นไม้ที่คุณชื่นชอบ ระยะเวลา และแท็กเพื่อการโฟกัสอย่างรวดเร็ว`)
};

const tr_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı odaklanma için favori ağaç türlerini, sürelerini ve etiketlerini kaydet.`)
};

const zh_cn_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`储存常用的树种、时长和标签，快速专注`)
};

const zh_tw_subscription_exclusive_feature_favorite_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存常用的樹種、時長、標籤，快速專注`)
};

/**
* | output |
* | --- |
* | "Save your favorite tree species, durations, and tags for quick focus." |
*
* @param {Subscription_Exclusive_Feature_Favorite_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_favorite_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Favorite_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Favorite_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_favorite_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_favorite_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_favorite_subtitle(inputs)
});